import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import SkeletonGrid from '@zenbusiness/zui/SkeletonGrid';

import { ProductCard as ProductCardWithPrice } from '#client/components/ProductCard';

import * as Styled from './ProductCardsList.style';

function ProductCardList({ onOpenModal, loading, productCards }) {
  if (loading) {
    return <SkeletonGrid columns={2} count={6} />;
  }

  return (
    <Styled.Root component="ul">
      {productCards.map((card) => {
        // Because Chase card and Bank of America have the same title,
        // so we need use another prop for chase card key
        const cardKey = card.primaryCta?.modalName || card.title;
        const cardEventProps = {
          elementValue: cardKey,
          elementPosition: 'product_cards',
          appSection: 'home'
        };

        return (
          <Box
            component="li"
            key={cardKey}
            sx={{ display: 'flex' }}
          >
            <ProductCardWithPrice
              categories={[]}
              description={card.description}
              estimate={card.estimate}
              eventProps={cardEventProps}
              imageUrl={card.imageUrl}
              onClick={onOpenModal}
              partnerImageUrl={card.partnerImageUrl}
              primaryCta={card.primaryCta}
              product={card.product}
              status={card.status}
              title={card.title}
            />
          </Box>
        );
      })}
    </Styled.Root>
  );
}

ProductCardList.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  productCards: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default ProductCardList;
